<h2 mat-dialog-title>Add new fuel fee</h2>
<form [formGroup]="fuelFeeForm">
  <mat-dialog-content class="fields-container">
    <mat-form-field appearance="fill">
      <mat-label>Fuel fee</mat-label>
      <input matInput formControlName="name" name="name" maxlength="50" />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>SAP Name</mat-label>
      <input matInput formControlName="sapName" name="sapName" maxlength="50" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      [disabled]="!fuelFeeForm.valid"
      (click)="onAdd()"
    >
      Add
    </button>
  </mat-dialog-actions>
</form>
